import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const DownloadSection = ({ createPdf }) => (
  <div className='download-options'>
    <span className='qr-code'>
      <span id='spanforqr' className='qr-code-dynamic'></span>
      <FormattedMessage
        id='tutorials.scan'
        defaultMessage='Scan QR code to download'
      />
    </span>
    <span className='separator'>
      <FormattedMessage id='tutorials.or' defaultMessage='OR' />
    </span>
    <span
      className='btn btn-gradient-border'
      onClick={() => {
        createPdf();
      }}
    >
      <FormattedMessage
        id='looks.downloadPdf'
        defaultMessage='Download Tutorial'
      />
    </span>
  </div>
);

DownloadSection.propTypes = { createPdf: PropTypes.func };

export default DownloadSection;
